import { BOW_TIE_SIDE } from '../constants';
import BowTieControl from './BowTieControl';

function BowTieBranch({ branch, side, index, disabled, onControlClick }) {
  const name = branch.nome;
  const branchId = branch?.id ?? index;
  const isPreventive = side === BOW_TIE_SIDE.PREVENTIVO;
  const controles = branch?.controles || [];
  const hasControls = controles.length > 0;
  const node = (
    <div
      className={`bow-tie__node bow-tie__node--${
        isPreventive ? 'cause' : 'consequence'
      }`}
      title={name.length > 80 ? name : undefined}
    >
      {name}
    </div>
  );
  const controlesList = (
    <div className="bow-tie__controls">
      {controles.map((control, controlIndex) => (
        <BowTieControl
          key={`${side}-${branchId}-${
            control?.riscoPontoControleId ?? control?.id ?? controlIndex
          }`}
          control={control}
          side={side}
          branch={branch}
          branchId={branchId}
          index={controlIndex}
          disabled={disabled}
          onClick={onControlClick}
        />
      ))}
    </div>
  );

  return (
    <div
      className={`bow-tie__branch bow-tie__branch--${side}${
        hasControls
          ? ' bow-tie__branch--with-controls'
          : ' bow-tie__branch--without-controls'
      }`}
    >
      <span className="bow-tie__branch-connector" aria-hidden="true" />
      {isPreventive ? (
        <>
          {node}
          {controlesList}
        </>
      ) : (
        <>
          {controlesList}
          {node}
        </>
      )}
    </div>
  );
}

export default BowTieBranch;
